import {MenuItem, TextField as MuiTextField} from "@mui/material";
import {useField} from "formik";
import {useFormikFieldError} from "../utils";
import {useId} from "react";

export default function TextField(props) {
    const [field, meta, helpers] = useField(props);
    const {onChange, value, onBlur, ...otherFields} = field;
    const {
        helperText = ' ',
        select = false,
        upperCase = false,
        lowerCase = false,
        isReading = false,
        options = null,
        sortOptions = false,
        afterBlur = null,
        apiError,
        name,
        sx,
        ...otherProps
    } = props;
    const id = useId();

    // Optionally show dropdown options alphabetically by their label, keeping
    // the "Select" placeholder (key "-1") pinned to the top.
    let optionEntries = select && options ? Object.entries(options) : [];
    if (sortOptions) {
        optionEntries = optionEntries.slice().sort((a, b) => {
            if (a[0] === '-1') return -1;
            if (b[0] === '-1') return 1;
            return String(a[1]).localeCompare(String(b[1]));
        });
    }

    function handleBlur(e) {
        onBlur(e);
        if (afterBlur) afterBlur(e.target.value);
    }

    const {error, textFieldHelperText} = useFormikFieldError(meta, name, apiError, helperText)

    function handleChange(e) {
        if (upperCase) {
            helpers.setValue(e.target.value.toUpperCase(), true);
        } else if (lowerCase) {
            helpers.setValue(e.target.value.toLowerCase(), true);
        } else {
            onChange(e);
        }
    }

    return (
        <MuiTextField
            select={select}
            error={error}
            variant={'standard'}
            size={"small"}
            id={id}
            autoComplete="off"
            InputProps={{
                autoComplete: "off",
                readOnly: isReading,
                disableUnderline: isReading,
            }}
            helperText={textFieldHelperText}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            value={value !== null ? value : ''}
            {...otherProps}
            {...otherFields}
            onBlur={handleBlur}
            sx={{
                "& .MuiInputBase-input": {
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                ...sx
            }}
            FormHelperTextProps={{
                component: "div"
            }}
        >
            {
                select && options && optionEntries.map(([key, value]) => (
                    <MenuItem
                        key={key}
                        value={key}
                    >
                        {value}
                    </MenuItem>
                ))
            }
        </MuiTextField>
    )

}